import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const statisticManuscript = new Restful(project, 'statistic/manuscript')
statisticManuscript.getData = data => {
  const url = project + 'statistic/manuscript/data'
  return http.get(url, data).then(res => {
    return res
  })
}
statisticManuscript.exportData = data => {
  const url = project + 'statistic/manuscript/export'
  return http.octetget(url, data).then(res => {
    res.url = window.URL.createObjectURL(res.file)
    return res
  })
}
statisticManuscript.exportReview = data => {
  const url = project + 'statistic/reviewer/export'
  return http.octetget(url, data).then(res => {
    res.url = window.URL.createObjectURL(res.file)
    return res
  })
}

const statisticArticle = new Restful(project, 'statistic/article')
statisticArticle.getData = data => {
  const url = project + 'statistic/article/data'
  return http.get(url, data).then(res => {
    return res
  })
}
statisticArticle.exportData = data => {
  const url = project + 'statistic/article/data/export'
  return http.octetget(url, data).then(res => {
    res.url = window.URL.createObjectURL(res.file)
    return res
  })
}
const statisticReviewer = new Restful(project, 'statistic/reviewer')
statisticReviewer.exportData = data => {
  const url = project + 'statistic/reviewer/data/export'
  return http.octetget(url, data).then(res => {
    res.url = window.URL.createObjectURL(res.file)
    return res
  })
}

const statisticSpecial = new Restful(project, 'statistic/special')
statisticSpecial.getCharts = data => {
  const url = project + 'statistic/special/view'
  return http.get(url, data).then(res => {
    return res
  })
}

const statisticMcountry = new Restful(project, 'statistic/mcountry')
statisticMcountry.mcountry = (numType, data) => {
  const url = project + 'statistic/mcountry/' + numType
  return http.get(url, data).then(res => {
    return res
  })
}

const statisticMtype = new Restful(project, 'statistic/mtype')
statisticMtype.mcountry = (numType, data) => {
  const url = project + 'statistic/mtype/' + numType
  return http.get(url, data).then(res => {
    return res
  })
}

const statisticJournalCountry = new Restful(
  project,
  'statistic/journal/country'
)
statisticJournalCountry.zone = data => {
  const url = project + 'statistic/journal/country/zone'
  return http.get(url, data).then(res => {
    return res
  })
}

statisticJournalCountry.issue = data => {
  const url = project + 'statistic/journal/country/issue'
  return http.get(url, data).then(res => {
    return res
  })
}

const statisticJournalAtype = new Restful(project, 'statistic/journal/atype')
const statisticJournalAtypeAlert = new Restful(
  project,
  'statistic/journal/atype/alert'
)

const statisticPublisherAtype = new Restful(
  project,
  'statistic/publisher/atype'
)

export default statisticManuscript
export {
  statisticManuscript,
  statisticArticle,
  statisticMcountry,
  statisticMtype,
  statisticSpecial,
  statisticReviewer,
  statisticJournalCountry,
  statisticJournalAtype,
  statisticJournalAtypeAlert,
  statisticPublisherAtype
}
